//request.js
import axios from 'axios'
import {
    Toast
} from 'vant'

const url = 'https://ips.yhbyf.com' //  线上

//  有电豹B端
const ydbReq = axios.create({
    baseURL: 'https://bs.lindianshare.com', //  上线和测试同步
    // timeout: 100000 // 请求超时时间                                   
})

// 不需要loading加载
const request = axios.create({
    baseURL: url,
    // timeout: 100000 // 请求超时时间                                   
})

// 有电豹B端
ydbReq.interceptors.request.use(config => {
    config.headers = config.headers || {}
    config.headers['clientType'] = 'BD_MP'
    return config
}, error => {
    return Promise.reject(error)
})

// 添加respone拦截器 不加载loading
request.interceptors.response.use(
    response => {
        return Promise.resolve(response.data)
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    console.log(401)
                    break;
                case 403:
                    console.log(403)
                    break;
                case 404:
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    })
                    console.log(404)
                    break;
                case 500:
                    console.log(500)
                    break;
            }
        }
        return Promise.reject(error.response)
    }
)

export const req = request //  没有loading
export { ydbReq }
